var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlaneEmptyState = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 249,
  height: 100,
  viewBox: "0 0 249 100",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  fill: "#DEE2FE"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M146.346 0c5.525 0 10.004 4.477 10.004 10s-4.479 10-10.004 10h55.112c5.525 0 10.004 4.477 10.004 10s-4.479 10-10.004 10h37.037c5.526 0 10.005 4.477 10.005 10s-4.48 10-10.005 10h-32.75c-5.525 0-10.004 4.477-10.004 10s4.479 10 10.004 10h2.05c5.525 0 10.005 4.477 10.005 10s-4.48 10-10.005 10H54.13c-5.525 0-10.005-4.477-10.005-10s4.48-10 10.005-10H35.682c-5.526 0-10.005-4.477-10.005-10s4.48-10 10.005-10h19.877c5.526 0 10.005-4.477 10.005-10s-4.48-10-10.005-10H10.505C4.979 40 .5 35.523.5 30s4.48-10 10.005-10h66.493c-5.525 0-10.005-4.477-10.005-10s4.48-10 10.005-10h69.348zm88.635 80.374c5.407 0 9.79 4.393 9.79 9.813 0 5.42-4.383 9.813-9.79 9.813-5.406 0-9.789-4.393-9.789-9.813 0-5.42 4.383-9.813 9.79-9.813z",
  transform: "translate(-55 -230) translate(55 230) matrix(-1 0 0 1 249 0)"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  fill: "#3F4246"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.715 38.083C72.165 40.028 109.583 41 112.965 41c5.076 0 24.53-6.857 24.53-6.857 2.52-1.116 2.944-4.515.775-6.218L105.717.6.715 38.083z",
  transform: "translate(-55 -230) translate(55 230) translate(77 25) translate(0 34)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#C1C3C9",
  stroke: "#3F4246",
  strokeWidth: 1.5,
  d: "M101.055 21.96v14.632L.715 71.647c-.046.017 2.115-1.312 2.158-1.335l97.14-49.868c.59 0 1.042 1.801 1.042 2.199",
  transform: "translate(-55 -230) translate(55 230) translate(77 25)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#3F4246",
  strokeWidth: 1.5,
  d: "M.968 71.858c-.543.07-.768-.326-.685-.356l100.772-34.911 6.278-2.052c2.514-.825 5.276-.052 7 1.956l14.68 17.087c2.211 2.573.594 6.567-2.783 6.878C43.084 68.013 1.33 71.813.968 71.858z",
  transform: "translate(-55 -230) translate(55 230) translate(77 25)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  stroke: "#3F4246",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M.91 71.384c-.084.043-.738.504-.738-.346S63.81 14.136 78.15 1.384c1.728-1.537 4.37-1.371 5.9.36l16.16 18.292c.426.484.279 1.24-.298 1.528L.91 71.384z",
  transform: "translate(-55 -230) translate(55 230) translate(77 25) translate(0 .1)"
}))))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlaneEmptyState);
export default ForwardRef;